<template>
  <b-card :title="$t('prizeWheel.manage')">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  variant="primary"
                  class="mb-1 mr-auto ml-1"
                  :to="{ name: 'addPrizeWheel'}"
              >
                {{ $t('common.new') }}
              </b-button>
              <b-col md="2">
                <b-form-group
                    :label="$t('common.title')"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="warning"
                  @click="update(1)"
                  class="mb-1 mr-1"
              >
                {{ $t('common.filter') }}
              </b-button>
            </div>
          </b-row>
        </div>
        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
        >
          <template #cell(StartDate)="data">
            {{ data.value | date }}
          </template>
          <template #cell(EndDate)="data">
            {{ data.value | date }}
          </template>
          <template #cell(Deactive)="data">
            <b-badge :variant="data.value ? 'danger' : 'success'">
              {{ data.value ? $t('common.deactive') : $t('common.active') }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <b-link :to="{ name: 'updatePrizeWheel', params: { id: data.item.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1" v-text="$t('common.loading')" />
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'prizeWheels',
  data() {
    return {
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        PerPage: 10,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: this.$t('common.title'),
        },
        {
          key: 'Description',
          label: this.$t('common.description'),
        },
        {
          key: 'StartDate',
          label: this.$t('common.startDate'),
          sortable: true,
        },
        {
          key: 'EndDate',
          label: this.$t('common.endDate'),
          sortable: true,
        },
        {
          key: 'Deactive',
          label: this.$t('common.status'),
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.get(this.$api.prizeWheel.getList, { params: this.filterOptions })
          .then(res => {
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    }
  },
}
</script>
